// PlaceValueAdditionDemo.js
import React from "react";

/**
 * This component demonstrates how to add two numbers
 * by splitting them into tens and ones.
 * 
 * Props:
 *  - tens, ones, tensToAdd, onesToAdd, resultTens, resultOnes
 *  - setTens, setOnes, setTensToAdd, setOnesToAdd
 *  - handleAddition (the function from Grade2MathLesson)
 */
export default function PlaceValueAdditionDemo({
  tens, 
  ones, 
  tensToAdd, 
  onesToAdd,
  resultTens,
  resultOnes,
  setTens, 
  setOnes, 
  setTensToAdd, 
  setOnesToAdd,
  handleAddition
}) {
  return (
    <div style={{ border: "1px solid #ccc", padding: "10px", marginTop: "15px" }}>
      <h4>Place Value Addition Demo</h4>
      <p>Enter tens &amp; ones for two numbers, then click “Add.”</p>

      <div>
        <label>
          <strong>First Number:</strong>
          <br />
          Tens:{" "}
          <input
            type="number"
            value={tens}
            onChange={(e) => setTens(+e.target.value || 0)}
            style={{ width: "60px", marginRight: "10px" }}
          />
          Ones:{" "}
          <input
            type="number"
            value={ones}
            onChange={(e) => setOnes(+e.target.value || 0)}
            style={{ width: "60px" }}
          />
        </label>
      </div>

      <div style={{ marginTop: "10px" }}>
        <label>
          <strong>Second Number:</strong>
          <br />
          Tens:{" "}
          <input
            type="number"
            value={tensToAdd}
            onChange={(e) => setTensToAdd(+e.target.value || 0)}
            style={{ width: "60px", marginRight: "10px" }}
          />
          Ones:{" "}
          <input
            type="number"
            value={onesToAdd}
            onChange={(e) => setOnesToAdd(+e.target.value || 0)}
            style={{ width: "60px" }}
          />
        </label>
      </div>

      <button
        style={{ marginTop: "10px" }}
        onClick={handleAddition}
      >
        Add
      </button>

      <p style={{ marginTop: "10px" }}>
        <strong>Result Tens:</strong> {resultTens}, 
        <strong> Ones:</strong> {resultOnes} <br />
        ⇒ Total: <strong>{(resultTens * 10) + resultOnes}</strong>.
      </p>
    </div>
  );
}
